const resourceUrls = {
    getTests: {
        url: '/resource/actions/getTests'
    },
    removeTest: {
        url: '/resource/actions/deleteTest'
    },
    addTest:{
        url:'/resource/actions/addTest'
    }
    
    
};

export default resourceUrls;